// extracted by mini-css-extract-plugin
export default {"Rotating":"UpdateReportButton_Rotating__RHlY+","rotate":"UpdateReportButton_rotate__ed+xC"};